import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Shared/URL.js";
import axiosInstance from "../../Shared/axiosInstance.js";




export default function SaleDetails() {
  const { id } = useParams();
  const [sale, setSale] = useState(null);
  const [downloading, setDownloading] = useState(false);
   const navigate = useNavigate();
 


  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const { data } = await axiosInstance.get(`/Sale/get-sale/${id}`);
        setSale(data.data);
      } catch (err) {
        console.error("خطأ في تحميل تفاصيل البيع:", err);
        Swal.fire("خطأ", "فشل في تحميل تفاصيل البيع", "error");
      }
    };
    fetchDetails();
  }, [id]);

  const handleDownloadPdf = async () => {
    setDownloading(true);
    try {
      const response = await axiosInstance.get(`/Sale/get-sale-pdf/${id}`, {
        responseType: "blob",
      });

      if (response.data.type === "application/json") {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        Swal.fire("خطأ", errorData.message || "فشل في إنشاء ملف PDF", "error");
        return;
      }

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `فاتورة_بيع_${id}_${new Date().toISOString().split("T")[0]}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "تم التحميل",
        text: "تم تحميل ملف PDF بنجاح",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("خطأ في تحميل PDF:", err);
      Swal.fire("خطأ", "فشل في تحميل ملف PDF", "error");
    } finally {
      setDownloading(false);
    }
  };

  if (!sale) {
    return (
      <div className="container mt-5 pt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">جارٍ التحميل...</span>
        </div>
        <p className="mt-3">جاري تحميل تفاصيل البيع...</p>
      </div>
    );
  }

  const totalPaid = sale.payments?.reduce((sum, p) => sum + p.amount, 0) || 0;
  const remaining = Math.max(sale.totalAmount - totalPaid, 0);

  return (
    <div className="mt-5 pt-5" dir="rtl">
      {/* أزرار الإجراءات */}
      <div className="container mb-3" style={{ maxWidth: "900px" }}>
        <div className="d-flex gap-2">
          <button
            onClick={handleDownloadPdf}
            disabled={downloading}
            style={{
              background: downloading ? "#94a3b8" : "#2563eb",
              color: "white",
              padding: "12px 24px",
              borderRadius: "6px",
              border: "none",
              fontSize: "16px",
              fontWeight: "600",
              cursor: downloading ? "not-allowed" : "pointer",
              boxShadow: "0 2px 8px rgba(37, 99, 235, 0.3)",
              transition: "all 0.3s ease",
            }}
          >
            {downloading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                جاري إنشاء PDF...
              </>
            ) : (
              <>📥 تحميل PDF</>
            )}
          </button>
          <button
            className="btn btn-outline-secondary"
            onClick={() => window.history.back()}
          >
            ← رجوع
          </button>


<button
  style={{
    background: "#22c55e",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "600",
    fontSize: "17px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap"
  }}
  onClick={() => navigate(`/sales/${id}/add-payment-sale`)}
>
  إضافة دفعة
</button>

        </div>
      </div>

      {/* محتوى الفاتورة */}
      <div className="container mb-5" style={{ maxWidth: "900px" }}>
        <div
          style={{
            background: "#ffffff",
            border: "2px solid #93c5fd",
            borderRadius: "8px",
            padding: "40px",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          {/* رأس الفاتورة */}
          <div
            style={{
              borderBottom: "3px solid #60a5fa",
              paddingBottom: "20px",
              marginBottom: "30px",
            }}
          >
            <h3 style={{ color: "#2563eb", fontSize: "32px", fontWeight: "700", marginBottom: "5px" }}>
              فاتورة بيع
            </h3>
            <div style={{ color: "#64748b", fontSize: "16px" }}>
              رقم الفاتورة: <strong>{id}</strong>
            </div>
            <div style={{ color: "#64748b", fontSize: "16px" }}>
              التاريخ: {new Date(sale.saleDate).toLocaleDateString("ar-EG")}
            </div>
          </div>

          {/* بيانات العميل */}
          <div style={{ marginBottom: "30px" }}>
            <div className="row">
              <div className="col-md-6">
                <div style={{ color: "#64748b", fontSize: "14px", marginBottom: "4px" }}>العميل</div>
                <div style={{ color: "#000", fontSize: "20px", fontWeight: "600" }}>{sale.customerName}</div>
                <div style={{ color: "#000", fontSize: "20px", fontWeight: "600" }}>{sale.customerDetails}</div>
              </div>
              <div className="col-md-6 text-end">
                <span
                  style={{
                    background:
                      sale.paymentStatus === "Paid"
                        ? "#dcfce7"
                        : sale.paymentStatus === "PartiallyPaid"
                        ? "#fef3c7"
                        : "#fee2e2",
                    color:
                      sale.paymentStatus === "Paid"
                        ? "#15803d"
                        : sale.paymentStatus === "PartiallyPaid"
                        ? "#b45309"
                        : "#b91c1c",
                    padding: "8px 18px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "600",
                    border:
                      sale.paymentStatus === "Paid"
                        ? "1px solid #86efac"
                        : sale.paymentStatus === "PartiallyPaid"
                        ? "1px solid #fcd34d"
                        : "1px solid #fca5a5",
                    display: "inline-block",
                  }}
                >
                  {sale.paymentStatus === "Paid"
                    ? "✓ مدفوع"
                    : sale.paymentStatus === "PartiallyPaid"
                    ? "⊙ مدفوع جزئيًا"
                    : "✗ غير مدفوع"}
                </span>
              </div>
            </div>
          </div>

          {/* جدول الأصناف */}
          <div style={{ marginBottom: "25px" }}>
            <h5 style={{ color: "#2563eb", fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
              الأصناف
            </h5>
            <div className="table-responsive">
              <table className="table mb-0" style={{ border: "1px solid #dbeafe" }}>
                <thead>
                  <tr style={{ background: "#dbeafe" }}>
                    <th style={thStyle}>المنتج</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>الفئة</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>العلامة التجارية</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>الكمية</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>سعر الوحدة</th>
                    <th style={{ ...thStyle, textAlign: "center" }}>الإجمالي</th>
                  </tr>
                </thead>
                <tbody>
                  {sale.items.map((item, index) => (
                    <tr key={index} style={{ background: index % 2 === 0 ? "#f8fafc" : "#ffffff" }}>
                      <td style={tdStyle}>
                        <div style={{ color: "#000", fontWeight: "600" }}>{item.productName}</div>
                        {item.productDescription && (
                          <div style={{ color: "#64748b", fontSize: "15px", marginTop: "2px", fontWeight: "600" }}>
                            {item.productDescription}
                          </div>
                        )}
                      </td>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{item.categoryName}</td>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{item.brandName}</td>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{item.quantity}</td>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{item.unitPrice.toLocaleString()} جنيه</td>
                      <td style={{ ...tdStyle, textAlign: "center" }}>{item.subTotal.toLocaleString()} جنيه</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* سجل المدفوعات */}
          {sale.payments && sale.payments.length > 0 && (
            <div style={{ marginBottom: "25px" }}>
              <h5 style={{ color: "#2563eb", fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
                سجل المدفوعات
              </h5>
              <div className="table-responsive">
                <table className="table mb-0" style={{ border: "1px solid #dbeafe" }}>
                  <thead>
                    <tr style={{ background: "#eff6ff" }}>
                      <th style={{ ...thStyle, textAlign: "center" }}>المبلغ</th>
                      <th style={{ ...thStyle, textAlign: "center" }}>التاريخ</th>
                      <th style={{ ...thStyle, textAlign: "center" }}>طريقة الدفع</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sale.payments.map((p, index) => (
                      <tr key={index} style={{ background: "#ffffff" }}>
                        <td style={{ ...tdStyle, textAlign: "center" }}>{p.amount.toLocaleString()} جنيه</td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>{new Date(p.date).toLocaleDateString("ar-EG")}</td>
                        <td style={{ ...tdStyle, textAlign: "center" }}>{p.method}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* الملخص الكلي */}




          <div style={{ borderTop: "2px solid #93c5fd", paddingTop: "20px", background: "#f8fafc", padding: "20px", borderRadius: "6px" }}>
            
            
                        <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}> الخصم:</span>
              </div>
              <div className="col-6 text-end">
                <span style={{ color: "#1e40af", fontSize: "22px", fontWeight: "700" }}>{sale.discountAmount.toLocaleString()} جنيه</span>
              </div>
            </div>
            
            
            
            <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>إجمالي المبلغ بعد الخصم:</span>
              </div>
              <div className="col-6 text-end">
                <span style={{ color: "#1e40af", fontSize: "22px", fontWeight: "700" }}>{sale.totalAmount.toLocaleString()} جنيه</span>
              </div>
            </div>






            <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>إجمالي المدفوع:</span>
              </div>
              <div className="col-6 text-end">
                <span style={{ color: "#2563eb", fontSize: "20px", fontWeight: "700" }}>{totalPaid.toLocaleString()} جنيه</span>
              </div>
            </div>
            <div className="row" style={{ borderTop: "2px solid #cbd5e1", paddingTop: "12px", marginTop: "8px" }}>
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px", fontWeight: "600" }}>المتبقي:</span>
              </div>
              <div className="col-6 text-end">
                <span style={{ color: remaining > 0 ? "#dc2626" : "#16a34a", fontSize: "24px", fontWeight: "700" }}>{remaining.toLocaleString()} جنيه</span>
              </div>
            </div>




          </div>

          {/* الفوتر */}
          <div style={{ marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #e2e8f0", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>
            <p style={{ margin: 0 }}>شكرًا لتعاملك معنا!</p>
            <p style={{ margin: "4px 0 0 0" }}>تم الإنشاء في {new Date().toLocaleString("ar-EG")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const thStyle = {
  color: "#1e40af",
  fontSize: "15px",
  padding: "12px",
  fontWeight: "600",
  border: "1px solid #bfdbfe",
};

const tdStyle = {
  padding: "12px",
  border: "1px solid #e0e7ff",
  fontSize: "16px",
  color: "#475569",
  fontWeight: "600",
};
